import { render, staticRenderFns } from "./MotivoList.vue?vue&type=template&id=6075ced1&scoped=true"
import script from "./MotivoList.vue?vue&type=script&lang=js"
export * from "./MotivoList.vue?vue&type=script&lang=js"
import style0 from "./MotivoList.vue?vue&type=style&index=0&id=6075ced1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075ced1",
  null
  
)

export default component.exports